import { Component, OnInit, Input, HostListener } from "@angular/core";
import { ThemeService } from "src/app/theme.service";
import { faInfoCircle, faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import * as _ from "lodash";

@Component({
  selector: "app-home-experience",
  templateUrl: "./home-experience.component.html",
  styleUrls: ["./home-experience.component.css"],
})
export class HomeExperienceComponent implements OnInit {
  @Input() navigate;
  faInfoCircle = faInfoCircle;
  faRedoAlt = faRedoAlt;
  resizeEvent: () => void;
  display: boolean = false;

  load() {
    this.display = true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resizeEvent();
  }

  constructor(public themeService: ThemeService) {
    this.resizeEvent = _.throttle(() => document.getElementById("threed").attributes[2].value += "", 600);
  }

  ngOnInit(): void {}
}
